/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

export const Ac03: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  // Zaktualizowane teksty domyślne
  const [text1, setText1] = useState<string>("Pamiątka Chrztu Świętego");
  const [text2, setText2] = useState<string>("Amelki");
  const [text3, setText3] = useState<string>("Amelki");
  const [text4, setText4] = useState<string>("od Mamy Chrzestnej Alicji");
  const [text5, setText5] = useState<string>("21.04.2021"); // Zmieniona data

  // Zaktualizowane bazowe rozmiary czcionek
  const text1BasicSize = 50;
  const text2BasicSize = 54;
  const text3BasicSize = 60;
  const text4BasicSize = 40;
  const text5BasicSize = 30;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "215mm"; // PDF width in mm
  const pdfHeight = "223mm"; // PDF height in mm
  const maxWidth = 750; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'Allura-Regular'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'Allura-Regular'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'Allura-Regular'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  useEffect(() => {
    setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10));
  }, [text5]);


  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
      setCroppedAreaPixels(croppedAreaPixels);
    }, []);
  
    const handleShowCroppedImage = useCallback(async () => {
      if (image && croppedAreaPixels) {
        // Function to crop the image and get the result
        const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
        setCroppedImage(croppedImg);
        setStep("view");
      }
    }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
                onImageChange={(image) => setImage(image)}
                setStep={setStep}
              />
              {step === "crop" && (
                <p>
                  Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
                </p>
              )}
              <div style={{ }}>
                {step !== "crop" && (
                  <Button onClick={handleSave} disabled={isSaving}>
                    {isSaving ? "Zapisywanie..." : "Zapisz"}
                  </Button>
                )}
                {step === "crop" && (
                  <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
                )}
              </div>
      </div>
      

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Allura-Regular, CenturyGothic",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <div className="sw-01-text-wrapper" style={{}}>
          <InlineEdit
            value={text1}
            setValue={setText1}
            style={{
              fontSize: `${fontSizeText1}px`,
              lineHeight: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '82px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Allura-Regular',
              color: "#2b2a29",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          {/* <InlineEdit
            value={text2}
            setValue={setText2}
            style={{
              fontSize: `${fontSizeText2}px`,
              lineHeight: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '600px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'AphroditeSlimPro',
              color: "#2b2a29",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          /> */}
          <InlineEdit
            value={text3}
            setValue={setText3}
            style={{
              fontSize: `${fontSizeText3}px`,
              lineHeight: `${fontSizeText3}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '144px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Allura-Regular',
              color: "#2b2a29",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />

          {/* <InlineEdit
            value={text4}
            setValue={setText4}
            style={{
              fontSize: `${fontSizeText4}px`,
              lineHeight: `${fontSizeText4}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '116px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'AphroditeSlimPro',
              color: "#2b2a29",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          /> */}

          <InlineEdit
            value={text5}
            setValue={setText5}
            style={{
              fontSize: `${fontSizeText5}px`,
              lineHeight: `${fontSizeText5}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '92px', // Zmienione położenie
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'CenturyGothic',
              color: "#2b2a29",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />
        </div>

        {/* Step: Crop */}
              {image && step === "crop" && (
                <CropperWrapper
                  image={image}
                  crop={crop}
                  zoom={zoom}
                  aspect={313 / 362}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={handleCropComplete}
                  style={{
                    width: "313px",
                    height: "362px",
                    position: "absolute",
                    top: "271px",
                    left: "248px",
                    clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                    objectFit: "cover",
                    zIndex: 4,
                    transform: "none"
                  }}
                />
              )}
        
              {/* Step: View */}
              {croppedImage && step === "view" && (
                <img
                  src={croppedImage}
                  style={{
                    width: "313px",
                    height: "362px",
                    position: "absolute",
                    top: "271px",
                    left: "248px",
                    clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
                    objectFit: "cover",
                    zIndex: 2
                  }}
                />
              )}


        <img
          src="/images/AC03.svg"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};